<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Novo Pedido</h3>
            </div>
            <div class="col-auto">
            </div>
          </div>
        </div>
      </div>

      <div class="element-box">
        <transition>
          <router-view></router-view>
        </transition>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  methods: {
    novoPedido() {
      this.$router.push({ name: "PedidoForm" });
    },
    listagem() {
      this.$router.push({ name: "PedidoList" });
    }
  }
}
</script>